module.exports = __webpack_public_path__ + "static/media/finish_line_amber.cd02b79c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/finish_line_amber.svg
// module id = 1103
// module chunks = 2